import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../config/api_url";
import { getData } from '../../config/AxiosFunction'
export const GetAllUser = createAsyncThunk("users/getAllUser",
    async () => {
        const responseData = await getData(`${api}users`, "get");
        return responseData;
    });
export default GetAllUser;
